import { Link } from "react-router-dom";
import Breadcrumb from "@/components/base/Breadcrumb";

export default function AboutPage() {
  return (
    <>
      <main>
        {/* About Header */}
        <section className="pt-24 pb-10 md:pb-14 px-4 md:px-6 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                { label: "关于我们" },
              ]}
            />
            <div className="mt-6">
              <h1 className="font-heading text-3xl md:text-4xl text-foreground-900">
                关于我们
              </h1>
              <p className="text-sm md:text-base text-foreground-600 mt-3 leading-relaxed max-w-2xl">
                国产自拍指南致力于为自拍爱好者提供最专业、最实用的国产手机自拍知识，帮助每个人用国产设备拍出高质感自拍大片。
              </p>
            </div>
          </div>
        </section>

        {/* Brand Story */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-5">
                  我们的故事
                </h2>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                  国产自拍指南诞生于2024年，由一群热爱摄影和国产科技的年轻人创立。我们注意到，尽管国产手机在影像技术上取得了巨大进步，但很多用户并不知道如何充分发挥这些设备的能力。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                  我们相信，每一个人都值得拥有好看的自拍。不需要昂贵的进口设备，不需要专业的摄影棚——你手中的国产手机，加上正确的技巧，就足以创作出令人惊艳的自拍作品。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  从最初的几个人到如今的数万读者，我们始终坚持内容为本，用通俗易懂的语言传递专业的自拍知识。每一篇文章都经过精心编写和实测验证，确保读者能真正学到有用的东西。
                </p>
              </div>
              <div className="rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20minimal%20creative%20workspace%20with%20warm%20golden%20lighting%2C%20photography%20equipment%20and%20smartphone%20on%20wooden%20desk%2C%20artistic%20atmosphere%2C%20refined%20editorial%20style%2C%20soft%20shadows%2C%20clean%20aesthetic%2C%20cozy%20amber%20and%20cream%20tones&width=800&height=600&seq=about-brand-story&orientation=portrait"
                  alt="国产自拍指南工作室"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Values */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-5xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-12">
              我们的价值观
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="text-center p-8 rounded-xl bg-background-50 border border-background-200/70">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100/80 mb-5">
                  <i className="ri-heart-line text-2xl text-accent-600"></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-900 mb-3">真诚分享</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  我们坚持内容的真实性和可操作性。每一条技巧都经过实测，每一款设备都深度体验后才做推荐。不吹不黑，只说真话。
                </p>
              </div>
              <div className="text-center p-8 rounded-xl bg-background-50 border border-background-200/70">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100/80 mb-5">
                  <i className="ri-lightbulb-line text-2xl text-primary-600"></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-900 mb-3">通俗易懂</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  我们拒绝晦涩的专业术语。无论你是摄影小白还是进阶玩家，都能在我们的文章中找到清晰易懂的指导。
                </p>
              </div>
              <div className="text-center p-8 rounded-xl bg-background-50 border border-background-200/70">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-secondary-100/80 mb-5">
                  <i className="ri-group-line text-2xl text-secondary-600"></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-900 mb-3">社群共进</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  我们不仅提供知识，更打造一个自拍爱好者社群。在这里，你可以交流心得、分享作品、一起进步。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Reputation / Testimonials */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-5xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-3">
              读者评价
            </h2>
            <p className="text-sm text-foreground-600 text-center mb-12">
              来自自拍爱好者们的真实反馈
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="p-6 rounded-xl bg-background-100 border border-background-200/70">
                <div className="flex items-center gap-1 mb-4">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <div key={s} className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-sm text-primary-500"></i>
                    </div>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  "作为一个自拍小白，这个网站真的帮了我太多。从灯光布置到构图方法，每一步都有详细的指导。现在我朋友圈的照片终于不用开十级美颜了！"
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-accent-200 flex items-center justify-center">
                    <span className="text-accent-700 font-semibold text-sm">L</span>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">小李</p>
                    <p className="text-xs text-foreground-500">大学生 · 自拍爱好者</p>
                  </div>
                </div>
              </div>

              <div className="p-6 rounded-xl bg-background-100 border border-background-200/70">
                <div className="flex items-center gap-1 mb-4">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <div key={s} className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-sm text-primary-500"></i>
                    </div>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  "设备推荐文章太实用了！本来想买iPhone来自拍，看了你们的分析后发现国产旗舰完全够用，省了好几千。修图App的对比评测也很专业，醒图确实好用。"
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary-200 flex items-center justify-center">
                    <span className="text-primary-700 font-semibold text-sm">W</span>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">小王</p>
                    <p className="text-xs text-foreground-500">上班族 · 数码爱好者</p>
                  </div>
                </div>
              </div>

              <div className="p-6 rounded-xl bg-background-100 border border-background-200/70">
                <div className="flex items-center gap-1 mb-4">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <div key={s} className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-sm text-primary-500"></i>
                    </div>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  "旅行打卡地的推荐文章太棒了！跟着攻略去了好几个地方，每个都超级出片。现在我的小红书粉丝涨了不少，真心感谢这个网站。希望多更新一些打卡攻略！"
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-secondary-200 flex items-center justify-center">
                    <span className="text-secondary-700 font-semibold text-sm">M</span>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">小美</p>
                    <p className="text-xs text-foreground-500">旅行博主 · 内容创作者</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <div className="rounded-xl bg-background-50 border border-background-200/70 p-8 md:p-10">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
                联系我们
              </h2>
              <p className="text-sm text-foreground-600 mb-8 leading-relaxed">
                有任何问题、建议或者合作意向，欢迎通过以下方式联系我们。我们会在24小时内回复。
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="space-y-5">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100/80 flex-shrink-0">
                      <i className="ri-mail-line text-lg text-accent-600"></i>
                    </div>
                    <div>
                      <h4 className="font-heading text-sm text-foreground-900 mb-1">电子邮箱</h4>
                      <p className="text-sm text-foreground-600">contact@ziguo自拍指南.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100/80 flex-shrink-0">
                      <i className="ri-wechat-line text-lg text-primary-600"></i>
                    </div>
                    <div>
                      <h4 className="font-heading text-sm text-foreground-900 mb-1">微信公众号</h4>
                      <p className="text-sm text-foreground-600">国产自拍指南</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100/80 flex-shrink-0">
                      <i className="ri-map-pin-line text-lg text-secondary-600"></i>
                    </div>
                    <div>
                      <h4 className="font-heading text-sm text-foreground-900 mb-1">办公地址</h4>
                      <p className="text-sm text-foreground-600">广东省深圳市南山区科技园</p>
                    </div>
                  </div>
                </div>
                <div>
                  <h4 className="font-heading text-base text-foreground-900 mb-4">快速链接</h4>
                  <div className="grid grid-cols-2 gap-3">
                    <Link
                      to="/category/jiqiao"
                      className="flex items-center gap-2 px-4 py-3 rounded-lg bg-background-100 hover:bg-background-200 transition-colors text-sm text-foreground-700 cursor-pointer"
                    >
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-camera-lens-line text-accent-600"></i>
                      </div>
                      自拍技巧
                    </Link>
                    <Link
                      to="/category/shebei"
                      className="flex items-center gap-2 px-4 py-3 rounded-lg bg-background-100 hover:bg-background-200 transition-colors text-sm text-foreground-700 cursor-pointer"
                    >
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-smartphone-line text-primary-600"></i>
                      </div>
                      设备推荐
                    </Link>
                    <Link
                      to="/category/goutu"
                      className="flex items-center gap-2 px-4 py-3 rounded-lg bg-background-100 hover:bg-background-200 transition-colors text-sm text-foreground-700 cursor-pointer"
                    >
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-focus-3-line text-secondary-600"></i>
                      </div>
                      构图方法
                    </Link>
                    <Link
                      to="/category/houqi"
                      className="flex items-center gap-2 px-4 py-3 rounded-lg bg-background-100 hover:bg-background-200 transition-colors text-sm text-foreground-700 cursor-pointer"
                    >
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-image-edit-line text-accent-600"></i>
                      </div>
                      后期处理
                    </Link>
                    <Link
                      to="/category/dengguang"
                      className="flex items-center gap-2 px-4 py-3 rounded-lg bg-background-100 hover:bg-background-200 transition-colors text-sm text-foreground-700 cursor-pointer"
                    >
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-lightbulb-flash-line text-primary-600"></i>
                      </div>
                      灯光布置
                    </Link>
                    <Link
                      to="/category/meihua"
                      className="flex items-center gap-2 px-4 py-3 rounded-lg bg-background-100 hover:bg-background-200 transition-colors text-sm text-foreground-700 cursor-pointer"
                    >
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-magic-line text-secondary-600"></i>
                      </div>
                      手机美化
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "关于我们 - 国产自拍完全指南",
            "description": "国产自拍指南致力于为自拍爱好者提供最专业、最实用的国产手机自拍知识。了解我们的品牌故事、价值观与联系方式。",
            "url": "https://njaierbei.cn/about",
            "inLanguage": "zh-CN",
            "about": {
              "@type": "Organization",
              "name": "国产自拍指南",
              "foundingDate": "2024",
              "description": "专注于国产自拍技巧与设备推荐的在线内容平台",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "深圳市",
                "addressRegion": "广东省",
                "addressCountry": "CN",
              },
              "contactPoint": {
                "@type": "ContactPoint",
                "email": "contact@ziguo自拍指南.com",
                "contactType": "customer service",
                "availableLanguage": "Chinese",
              },
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "首页",
                "item": "https://njaierbei.cn",
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "关于我们",
              },
            ],
          }),
        }}
      />
    </>
  );
}